import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { ReactComponent as ArrowRightIcon } from 'modules/account/assets/arrow-right.svg';
import { useTranslation } from 'modules/i18n';

import translation from './back.translation';

interface Props {
  className?: string;
  link: string;
}

export function Back({ className, link }: Props): JSX.Element {
  const { t, keys } = useTranslation(translation);
  const { classes, cx } = useStyles();

  return (
    <Link to={link} className={cx(classes.container, className)}>
      <ArrowRightIcon />

      <Typography variant="body2">{t(keys.back)}</Typography>
    </Link>
  );
}

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    alignSelf: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    width: 'fit-content',
    textDecoration: 'none',
    marginBottom: theme.spacing(8),

    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
}));
